'use strict';

angular.module('studies')
    .component('studyMain', {
        templateUrl: 'js/modules/studies/components/main/template.html',
        controller: 'StudyController',
        bindings: {
            study: '<',
        },
    });
